// Styles for CobrandVanilaCarousel

import { toRem, baseVariables } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledCardCarousel = styled.div<{ variation: string }>`
  @media ${baseVariables.mediaQuery.xl} {
    display: ${props => (props.variation === 'combo' ? 'flex' : 'block')};
  }
  .aem-container:first-child {
    margin-left: 0;
  }
  .carousal_header {
    display: flex;
    flex-direction: ${props => (props.variation === 'combo' ? 'column' : ' row')};
    justify-content: ${props => (props.variation === 'combo' ? 'center' : ' space-between')};
    align-items: ${props => (props.variation === 'combo' ? 'flex-start' : ' unset')};
    width: auto;
    @media ${baseVariables.mediaQuery.md} {
      width: ${props => (props.variation === 'combo' ? 'auto' : 'auto')};
    }

    .carousal_header--cta {
      display: flex;
      align-items: ${props => (props.variation === 'combo' ? 'unset' : ' flex-end')};
      margin-right: ${props => (props.variation === 'combo' ? 0 : toRem(4))};
      text-wrap: nowrap;
    }
  }
  .personal-wrapper {
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.07);
    padding-top: 24px;
  }
  .card-tag {
    position: absolute;
    top: 0;
    left: 0;
    width: fit-content;
    padding: ${toRem(4)} ${toRem(16)};
    background-color: ${baseVariables.color.neutral30};
    text-transform: uppercase;
    line-height: ${toRem(14)};
    border-radius: ${toRem(8)} ${toRem(0)} ${toRem(4)} ${toRem(0)};
  }
  .glide {
    &__track {
      padding-top: ${toRem(24)};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
    }
    .glide__slides > .cq-Editable-dom > .cq-Editable-dom--container {
      display: contents;
    }
    &__track__pt3 {
      overflow: hidden;
      padding-top: ${toRem(8)};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
    }

    .center-align {
      display: block;
      width: 100%;
      margin-top: ${toRem(16)};

      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
      }
    }
  }
  .glide--swipeable {
    cursor: default;
  }

  /*
    CNWEB-7158
    Fixes z-index issue in Non-Desktop view where Explore Our Destinations
    carousel arrows overlapped the Search Form calendar pop-up.
  */
  @media ${baseVariables.mediaQuery.allTablets}, ${baseVariables.mediaQuery.mobile} {
    #cn-destinations-2 .glide__arrow {
      z-index: 1;
    }
  }
`;
